import React from "react";
import {Grid, Link, Typography} from "@mui/material";

import {makeLxTranslations, useLxTranslations} from "@lxo-blocks/react";
import {lxStyled} from "@lxo-blocks/react";

const PREFIX = 'PasswordForgotten';
const classes = {
    link: `${PREFIX}-link`
}
const PasswordForgottenContainer = lxStyled(Grid)(({theme}) => ({
    [`.${classes.link}`]: {
        color: `${theme.palette.text.secondary}`
    }
}));

const PASSWORD_FORGOTTEN_LINK_TRANSLATION = makeLxTranslations({
    namespace: "passwordForgottenLinkTranslations",
    translations: {
        PASSWORD_FORGOTTEN: "Passwort vergessen?",
    }
})

export default function PasswordForgottenLink(props: any) {
    const {t} = useLxTranslations(PASSWORD_FORGOTTEN_LINK_TRANSLATION);
    return <PasswordForgottenContainer container
                                       sx={props.sx}
                                       justifyContent="center">
        <Grid item>
            <Link className={`${classes.link}`} underline="none" href="/sign-in/forgot-password">
                <Typography component="div" variant="body2">{t("PASSWORD_FORGOTTEN")}</Typography>
            </Link>
        </Grid>
    </PasswordForgottenContainer>
}
